<!--
Este componente recibe como parametros las varibles de control de visibilidad de
las flechas de avanzar y retroceder (atrasVisible y adelanteVisible). También recibe los diálogoa reproducir.
El componente automáticamente actualiza el texto (currentText) y devuelve el nuevo valor
a través de la función :update:currentText para notificar al padre.
recibe instructor: Number (tres instructores)
NOTA: Se asume que los diálogos siempre van a empezar en el diálogo 0
-->
<template>
    <v-layout align-center justify-center row>
        <v-flex>
            <v-layout align-center justify-center wrap class="cont-dialogo">
                <v-flex class="personaje text-xs-center" xs12 md12 >
                    <img :src="require('@/assets/imagenes_compartidas/tucan-' + tucan + '.png')">
                </v-flex>
                <v-flex class="dialogos" xs12 md12>
                    <div @click="adelante" class="flecha-adelante diagnav hvr-scale-img"
                            v-show="adelanteVisible && currentText < dialogos.length - 1">
                        <img src="@/assets/imagenes_compartidas/Flecha_Izquierda_Dialogos.png" alt="">
                    </div>
                    <div @click="atras" class="flecha-atras diagnav hvr-scale-img"
                            v-show="atrasVisible && currentText>0">
                        <img src="@/assets/imagenes_compartidas/Flecha_Derecha_Dialogos.png" alt="">
                    </div>
                    <v-layout align-center justify-center class="ml-2" row>
                        <v-flex>
                            <p :id="'diag-'+idx" :key="idx" v-for="(dialogo, idx) in dialogos"
                               v-show="currentText == idx"><span v-html="dialogo"></span></p>
                            <slot></slot>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        props: {
            atrasVisible: {
                type: Boolean,
                default: true
            },
            adelanteVisible: {
                type: Boolean,
                default: true
            },
            dialogos: {
                type: Array,
                required: true
            },
            tucan: {
                type: Number,
                default: "0"
            }
        },
        data() {
            return {
                imgTucan: '',
                currentText: 0,
                arrTucan: [],
                background: ''
            }
        },
        created() {
            for (var i = 0; i < 2; i++) {
                this.getPng('', data => {
                    this.arrTucan.push(data);
                });
            }
            this.cambiarTucan(this.tucan);
        },
        methods: {
            atras() {
                this.currentText--;
                this.$emit('update:currentText', this.currentText);
            },
            adelante() {
                this.currentText++;
                this.$emit('update:currentText', this.currentText);
            },
            saltarAlDialogo(numeroDialogo) {
                this.currentText = numeroDialogo;
                this.$emit('update:currentText', this.currentText);
            },
            cambiarTucan(numTucan) {
                this.imgTucan = this.arrTucan[numTucan];
            }
        },
        watch: {
            Tucan: function (newVal, oldVal) { // watch it
                this.cambiarTucan(newVal);
            }
        }

    }
</script>

<style lang="scss" scoped>
    @import '../sass/globals';
    .personaje {
        z-index: 2;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin-bottom:-20px;
        img {
            width: 68px;
        }
    }

    .dialogos {
        position: relative;
        padding: 15px;
        // left: -30px;
        padding-left: 35px;
        padding-right: 35px;
        padding-top: 30px;
        margin: 0 auto;
        border-radius: 4px;
        text-align: center;
        p {
            margin: 0;
            font-size: 12px;
        }
        margin-bottom: 5px;
        background-color: #D3D2D2;
    }
    .cont-dialogo{
        // background-color: #D3D2D2;
        border-radius: 4px;
    }

    .diagnav {
        width:30px;
        height: 100%;
        cursor: pointer;
        right: 2px;
        color: black;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            width: 20px;
            height: 30px;
        }
        // background-image: url("../assets/imagenes_compartidas/nav-dialog.png");
    }
    .flecha-atras {
        left: 0px;
        top: 0;
    }
    .flecha-adelante {
        right: 0;
        top: 0;
    }

    p {
        font-family:Poppins-Regular;
        line-height: 1.3em;
    }

    // @media (max-width: 900px){
    //   .personaje {
    //     text-align: center;
    //     margin-bottom: 20px;
    //     left: 0px;
    //     img{
    //        width: 100px;
    //     }
    //   }
    //   .dialogos {
    //     left: 0;
    //     top: -50px;
    //     padding-top: 50px;
    //     margin-bottom: -40px;
    //     padding-left: 35px;
    //     padding-right: 35px;
    //   }
    //     .flecha-atras {
    //         left:0px;
    //     }
    // }
</style>
